
import { DeviceDimensions } from "@/api/dtos/DeviceDimensions.schema";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import CancelButton from "../buttons/CancelButton.vue";
import DangerButton from "../buttons/DangerButton.vue";
import EditFrame from "../EditFrame.vue";

@Component({
  components: {
    EditFrame,
    CancelButton,
    DangerButton,
  },
})
export default class DeviceDimensionsForm extends Vue {
  @Prop()
  deviceDimensions!: DeviceDimensions;

  @Prop({
    default: false,
  })
  hideControls!: boolean;

  @Prop({ default: false }) editMode!: boolean;

  editedDeviceDimensions: DeviceDimensions = {
    height: 0,
    width: 0,
    length: 0
  };

  dimensionRules = [
    (v: any) =>
      v !== null && v !== undefined && v !== "" || "Dieses Feld ist erforderlich.",
    (v: any) =>
      !isNaN(Number(v)) || "Bitte eine gültige Zahl eingeben.",
    (v: any) =>
      Number(v) > 0 || "Der Wert muss größer als 0 sein.",
  ];

  mounted(): void {
    this.importData();
  }

  @Watch("deviceDimensions")
  onDimensionsChanged(): void {
    this.importData();
  }

  importData(): void {
    this.editedDeviceDimensions.height = Math.round(this.deviceDimensions.height * 100);
    this.editedDeviceDimensions.width = Math.round(this.deviceDimensions.width * 100);
    this.editedDeviceDimensions.length = Math.round(this.deviceDimensions.length * 100);
  }

  onInput(): void {
    if (this.editedDeviceDimensions) {
      const updatedDimensions: DeviceDimensions = {
        height: this.toMeter(this.editedDeviceDimensions.height),
        width: this.toMeter(this.editedDeviceDimensions.width),
        length: this.toMeter(this.editedDeviceDimensions.length),
      }
      this.$emit("input", updatedDimensions);
    }
  }

  toMeter(value: number): number {
    // returns 2 decimal places. So 1.23, but never 1.234
    return Math.round(value / 100 * 100) / 100;
  }
}
